import { render, staticRenderFns } from "./tree-label.vue?vue&type=template&id=453bc006&"
import script from "./tree-label.vue?vue&type=script&lang=js&"
export * from "./tree-label.vue?vue&type=script&lang=js&"
import style0 from "./tree-label.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports